import React, { useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import "./index.scss";

const RootCauseData = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname.includes("/root-cause-data") &&
      !location.pathname.includes("/root-cause-data/")
    ) {
      navigate("./data-visualization", { replace: true });
    }
  }, [location.pathname]);
  return (
    <div className="full-width diagnostics-container">
      <div className="tabs-container">
        <NavLink
          to="./data-visualization"
          className={({ isActive }) =>
            isActive ? "btn-primary tabs" : "btn-secondary tabs"
          }
        >
          Data Visualization
        </NavLink>
        <NavLink
          to="./is-isnot-analysis"
          className={({ isActive }) =>
            isActive ? "btn-primary tabs" : "btn-secondary tabs"
          }
        >
          Is - Is Not Analysis
        </NavLink>
        <NavLink
          to="./ishikawa-diagram"
          className={({ isActive }) =>
            isActive ? "btn-primary tabs" : "btn-secondary tabs"
          }
        >
          Ishikawa Diagram
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
};

export default RootCauseData;
